import { useContext } from 'react';
import SEOContext from '~/contexts/SEOContext';
import { formatKeyWordAndLocation } from './utils';

export default function TitleTag() {
  const { vanityUrl } = useContext(SEOContext);

  return vanityUrl == null ? null : (
    <h1 className="m-0 t-label-s truncate w-full">
      {formatKeyWordAndLocation(vanityUrl)}
    </h1>
  );
}
